import { SxProps } from '@mui/material';

export const recentHeadingSx: SxProps = {
  fontWeight: 500,
  fontSize: 15,
  lineHeight: '22px',
  mb: 2,
};

export const emptyStateSx: SxProps = {
  fontWeight: 400,
  fontSize: 14,
  lineHeight: 1.4,
  letterSpacing: '-0.14px',
  color: 'custom.textSecondaryNew',
};

export const itemTitleSx: SxProps = {
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '20px',
  color: 'custom.surfaceDark',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  mb: 1,
};

export const itemSubtitleSx: SxProps = {
  fontWeight: 400,
  fontSize: 14,
  lineHeight: 1.4,
  letterSpacing: '-0.14px',
  color: 'custom.surfaceDark',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};
